const inventory = {
    carSchemaOwnerImage:
        'https://atcimages.kbb.com/images/direct/dealer_photo/2017/04/04/100002312/1491347656571/exterior_4.jpg',
    description: {
        hasMore: true,
        text: 'AWD - ALL WHEEL DRIVE, BACKUP CAMERA, ECOBOOST, HEATED SEATS, KEYLESS ENTRY, PUSH BUTTON START, Fusion SE, 4D Sedan, 2.0L, 6-Speed Automatic...',
    },
    features: [
        '3rd Row Seat',
        'Alloy Wheels',
        'Anti-Lock Brakes',
        'Backup Camera',
        'Bedliner',
        'Bluetooth',
        'CD Player',
        'Child Seat',
        'Cruise Control',
        'DVD Player',
        'Disability Equipped',
        'Fold-Flat Seats',
        'Heated Seats',
        'Keyless Entry',
        'Leather Seats',
        'Moonroof',
        'Multi-zone Climate Control',
        'Navigation',
        'Portable Audio Connection',
        'Power Locks',
        'Power Mirrors',
        'Power Seats',
        'Power Windows',
        'Premium Audio',
        'Premium Wheels',
        'Rear Window Defroster',
        'Satellite Radio',
        'Security System',
        'Side Curtain Airbags',
        'Steering Wheel Control',
        'Sunroof',
        'Tilt Wheel',
        'Tinted Glass',
        'Traction Control',
        'Trailer Hitch',
    ],
    fuelType: 'Gasoline',
    website: {
        href: '/cars-for-sale/vehicledetails.xhtml?listingId=462818379',
    },
    id: 462818379,
    images: {
        primary: 0,
        sources: [
            {
                alt: 'Listing Image Alt',
                src: 'https://via.placeholder.com/408x306',
            },
            {
                alt: null,
                src: 'https://via.placeholder.com/408x306',
            },
            {
                alt: null,
                src: 'https://via.placeholder.com/408x306',
            },
        ],
    },
    isNewlyListed: true,
    isReducedPrice: true,
    isHot: false,
    leadScheduling: false,
    accelerate: true,
    makeMyDeal: false,
    owner: {
        email: 'dfall@spitzer.com',
        hasTCPA: false,
        hideEmailForm: false,
        isIcoDealer: true,
        id: 18961316,
        images: {
            primary: 0,
            sources: [
                {
                    alt: null,
                    src: 'https://images.autotrader.com/borderscaler/544/408/2d363e/images/direct/dealer_photo/2014/03/31/98720/1396287508495/DSC01946.JPG',
                },
                {
                    alt: null,
                    src: 'http://via.placeholder.com/283x212',
                },
                {
                    alt: null,
                    src: 'http://via.placeholder.com/283x212',
                },
            ],
        },
        license: '0398292',
        logo: {
            src: '//images.autotrader.com/images/direct/116x49_static/2017/08/17/70418453/70418453_1502999412672_116x49_STATIC.jpeg',
        },
        name: 'Spitzer Ford Hartville',
        distanceFromSearch: 9.4,
        privateSeller: false,
        phone: {
            privateNumber: false,
            label: 'Phone number',
            value: '3308772252',
            linkText: "Get this seller's phone number",
            isVisible: true,
        },
        textNumber: '8883417978',
        ownerRating: 3.5,
        rating: {
            value: 3,
            // label: 'Reviews Powered by DealerRater',
            count: 147,
            apiKey: '8ee18e40-889d-11e9-bc42-526af7764f64',
            // non qa apiURL: https://dealerratings.syndication.kbb.com
            apiUrl: 'https://dealerratings.syndication.kbb.com',
        },
        dealerDiff: {
            id: 'Carvana',
            label: 'Ask about out 1.9% Financing',
        },
        location: {
            address: {
                address1: '2799 Piedmont Road NE',
                address2: null,
                city: 'Atlanta',
                state: 'GA',
                zip: '30305-2778',
            },
            map: {
                href: 'https://www.google.com/maps/search/?api=1&query=Monkey+Bacon+Dealer%2C5775+Peachtree+Dunwdy+%2CAtlanta%2CGA+94103',
            },
        },
        languages: ['English', 'Spanish', 'French'],
        homeServices: {
            vehicleDelivery: true,
            virtualTour: true,
            testDrive: true,
        },
        // availableTimes,
        disabledDaysOfWeek: [0],
        // hours,
        servicesAmenities: [
            'Service Centers',
            'Factory Authorized Service Center',
            'Parts & Accessories',
            'Detailing',
            'Customization',
            'Internet Access',
            'Comfortable Waiting Area',
            'Delivery Options',
            'Good Credit',
            'Classic/Collector',
        ],
        website: {
            href: 'http://www.lexusatlanta.com/',
        },
        shippingLabel: null,
        storeShipping: false,
        tagline: 'Obsessed with customers',
        virtual: false,
        isPayingDealer: true,
    },
    marketExtension: {
        description: null,
    },
    mileage: {
        label: 'MILEAGE',
        value: '15,000',
    },
    dealerConfig: {},
    priceAdvisor: {
        image: {
            src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg',

            alt: 'Price Advisor',
        },
        label: 'See the KBB Fair Market Range',
        showPriceAdvisor: true,
        hasStateRules: true,
        heading: 'Kelley Blue Book<span>&#174;</span> Fair Market Range',
        subheading:
            'Autotrader is displaying the Kelley Blue Book<span>&#174;</span> Price Advisor to help shoppers better understand vehicle pricing.',
    },
    priceValidUntil: '2023-05-07',
    pricingDetail: {
        msrp: 206870,
        salePrice: 206870,
        incentive: 172870,
        noPriceLabel: 'Contact Dealer For Price',
        discounts: [
            {
                label: 'Manufacturer Offers',
                value: 10000,
                expiration: '07/31/17',
                tooltip:
                    'Incentives from the automaker that any buyer might qualify for, usually as a result of a sales event or limited time promotion.',
            },
        ],
        reductions: [
            {
                label: 'Dealer Offer',
                value: 10000,
                tooltip: 'The amount the dealer has reduced the vehicle price below the MSRP.',
            },
            {
                label: 'Special Offers',
                value: 14000,
                tooltip:
                    'Incentives that only certain buyers might qualify for, such as discounts for college graduates or the military.',
            },
        ],
        payment: {
            label: 'Est. Finance Payment',
            value: 550,
            paymentDisclaimer:
                'Estimated payment based on 5.21% APR for 72 months with $4,970 down' +
                ' for well qualified buyers. Terms may vary.',
        },
        dealIndicator: 'Great',
        isMismatch: false,
    },
    quickViewFeatures: [
        '60-Inch Bed',
        'Alarm System',
        'Auxiliary Audio Input',
        'Blind Spot Alert',
        'Bluetooth, Hands-Free',
        'Brake Assist',
        'Collision Warning',
        'Compact Crew Cab',
        'Cruise Control',
        'Fog Lights',
        'Keyless Entry',
        'Leather Wrapped Steering Wheel',
        'Navigation System',
        'Parking assist',
        'Power Passenger Seat',
        'Power Windows',
        'Premium Sound System',
        'Premium Wheels',
        'Rearview Camera',
        'Satellite Radio',
        'Side Air Bag',
        'Steering Wheel Controls',
        'Sunroof',
    ],
    mpgCity: 17,
    mpgHighway: 20,
    specifications: {
        color: {
            label: 'Color',
            value: 'Black',
        },
        mpg: {
            label: 'MPG',
            value: '20 City / 29 Highway',
        },
        engine: {
            label: 'Engine',
            value: '4 Cylinder Turbo',
        },
        fuelType: {
            label: 'Fuel Type',
            value: 'Gasoline',
        },
        driveType: {
            label: 'Drive Type',
            value: 'All wheel drive',
        },
        interiorColor: {
            label: 'Interior Color',
            value: 'White',
        },
        mileage: {
            label: 'Miles',
            value: '15,000',
        },
        transmission: {
            label: 'Transmission',
            value: 'Automatic',
        },
        mileRange: {
            label: 'Mile Range',
            value: '16 Mile EV Range',
        },
    },
    productTiles: [
        {
            linkVisible: false,
            // label field created by configureListingTiles.js in find-car
            label: 'AUTOCHECK',
            epn: 'enterprise',
            image: {
                src: 'https://www.autotrader.com/cm-api/content/static/img/vhr/experian/210825.png',
                height: 31,
                title: 'Some Title',
            },
            link: {
                href: 'https://www.autotrader.com/',
                alt: 'dummy alt text',
                label: 'Get AutoCheck Vehicle History',
                offsite: true,
            },
            tileType: 'EXPERIAN_RETAIL',
        },
    ],
    products: {
        accelerate: true,
    },
    certifiedTiles: [
        {
            image: {
                src: '//images.autotrader.com/cms/images/na/certified/cpo/218484.png',
                height: 31,
                title: 'Some Title',
            },
            label: 'NISSAN CERTIFIED',
            link: {
                href: 'https://www.autotrader.com/',
                alt: 'dummy alt text',
                label: 'blah blah blah',
                offsite: true,
            },
        },
    ],
    title: 'New 2017 Ford Fusion T6 Cross Country',
    type: 'New',
    listingType: 'New',
    vin: 'WUAKBAFX5J7900398',
    stockNumber: '74339',
    priority: 'Premium',
    year: 2018,
    make: 'Volvo',
    makeCode: 'VOLVO',
    model: 'V90',
    modelCode: 'V90',
    bodyStyleCodes: ['SUV'],
    trim: 'T6 Cross Country',
    styleId: 392829,
    hasDR: false,
    style: 'Sedan',
    hasSpecialOffer: false,
    zip: '30456',
    resources: {
        additionalResources: [
            {
                cmp: 'get_loan_txt',
                epn: 'CapitalOne',
                image: {
                    alt: 'Capital One',
                },
                link: {
                    label: 'capital one label',
                },
                title: 'Car Loans',
            },
            {
                cmp: 'ns_tim',
                epn: 'InstantCashOffer',
                image: {
                    alt: 'instant cash offer',
                },
                link: {
                    label: 'ico label',
                },
                title: 'KBB Instant Cash Offer',
            },
            {
                cmp: 'ny_syc',
                image: {
                    alt: 'Experian',
                },
                link: {
                    label: 'Get Your FICO&#174; Score for Free',
                },
                title: 'Credit Report',
            },
            {
                cmp: 'apply_crd_vw_wb_btn',
                link: {
                    label: 'Finance with us',
                    href: 'https://www.autotrader.com',
                },
                title: 'Finance with Spitzer Ford Hartville',
            },
        ],
    },
};

export default {
    catalog: 'atc',
    brand: 'atc',
    application: {
        environment: 'qa',
        name: 'web',
        version: '1.0.0',
    },
    user: {
        zipCode: '30328',
        isLoggedIn: 0,
    },
    page: {
        experimentId: [],
        pageName: 'srp',
        pg: 'fyc_srl',
        siteSection: 'find-your-car',
        pageType: 'srp',
        detailPageName: 'srp',
        pixallABC: 'pixAllABC',
        pixallId: 'pixAllPXAId',
        pixallPageInstanceId: '1234',
    },
    consumerInsights: {
        preferredMake: 'BMW',
    },
    consumerMetadata: {
        myConsumerId: '01FVCSTNGDYKYY3EKARQX3KFXE',
        email: 'abc@gmail.com',
        phoneNumber: '4123213213',
    },
    search: {
        filters: {
            startYear: '2000',
        },
    },
    inventory,
    vehicle: {
        ...inventory,
        exteriorColorSimple: 'Blue',
        additionalInfo: {
            vehicleDescription: 'Description',
        },
        classSeries: '3 Series',
        classSeriesCode: '3_Series',
        videoId: '12345',
    },
};
